import React from 'react'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import PostList from '../components/PostList'
import PostSpotlight from '../components/PostSpotlight'
import Pagination from '../components/Pagination'
import Babypedia from '../components/Babypedia'

export const Category = props => {
  const { data, pageContext } = props
  const { nodes: posts } = data.allWpPost
  const { title: siteTitle } = data.site.siteMetadata
  const { name: category } = pageContext
  const title = `${posts.length} post${
    posts.length === 1 ? '' : 's'
  } na categoria “${category}”`

  return (
    <Layout>
      <Helmet title={`${category} | ${siteTitle}`} />
      <Babypedia title />
      <PostSpotlight />
      <PostList posts={posts} title={title} />
      <Pagination pageContext={pageContext} pathPrefix="/" />
    </Layout>
  )
}

export default Category

export const pageQuery = graphql`
  query CategoryPage($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allWpPost(
      filter: { categories: { nodes: { elemMatch: { slug: { eq: $slug } } } } }
      sort: { fields: date, order: DESC }
    ) {
      nodes {
        excerpt
        id
        title
        slug
        featuredImage {
          node {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
        categories {
          nodes {
            id
            name
            categorias {
              color
              imagemPadrao {
                sourceUrl
                localFile {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
